<template>
  <img 
    src="https://i.ibb.co/gM9m44Fd/favicon-98x98.png" 
    alt="TechnoAI" 
    class="h-10 w-auto object-contain mx-auto" 
  />
</template>
